export * from '@fhs/routing/src/routes/v2/order/_layout';
export { default } from '@fhs/routing/src/routes/v2/order/_layout';
